import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import * as actions from '../../../../redux/user/actions.user';
import * as analyticsActions from '../../../../redux/analytics/actions.analytics';
import GithubButton from '../../../components/GithubButton/GithubButton';
import GoogleButton from '../GoogleButton/GoogleButton';
import showOauthDialog from '../../../../services/mini/showOauthDialog';
import signInLogo from '../../../../assets/images/login/icon-mail-small.svg';
import userVerificationEvents from '../../../../const/userVerificationEvents';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import isValidEmail from '../../../../services/mini/isValidEmail';
import ValidationForm from '../../../forms/ValidationForm';
import LoginFormSubtitle from '../LoginFormSubtitle/LoginFormSubtitle';
import GaService from '../../../../services/GaService';
import { isAnyAuthAvailable, isGithubAuthAvailable, isGoogleAuthAvailable, isEmailAuthAvailable } from '../../../../utils/env/loginEnv';
import { routeInfo } from '../../../../routeInfo';

class SignInForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        const { verify, hex, code, accountType } = this.props;

        this.state = {
            tryingToSignUpAutomaticallyAfterVerifiengEmail: !!(verify && hex),
            googleLogInInProcess: !!(code && accountType === 'google'),
            githubLogInInProcess: !!(code && accountType === 'github')
        };
    }

    componentDidMount() {
        const {
            verify,
            email,
            code,
            hex,
            trackUserAction,
            sendVerifySignUpRequest,
            accountType,
            invitationCode,
            stateFromUrl
        } = this.props;

        const param = {
            email,
            hex
        };

        if (verify && param.hex) {
            // there is a problem on the backend with sync verify/user tables, 
            // so here we have to wait result from trackUserAction call (requested by Yuriy)
            trackUserAction({ action: userVerificationEvents.signInFormOpened, ...param }).then(() => {
                const newState = { tryingToSignUpAutomaticallyAfterVerifiengEmail: true };
                this.setState(newState, () => {
                    trackUserAction({ action: userVerificationEvents.sendVerifyRequest, ...param });
                    sendVerifySignUpRequest(param).then(() => { }, (e) => {
                        trackUserAction({ action: userVerificationEvents.sendVerifyRequestError, ...param, data: { error: e } });
                        this.setState({ tryingToSignUpAutomaticallyAfterVerifiengEmail: false });
                    });
                });
            });
        }

        if (code) {
            if (accountType === 'github') {
                this.props.githubSignIn({ code, invitationCode });
            } else if (accountType === 'google') {
                let invitationCodeFromStateOauth;
                try {
                    invitationCodeFromStateOauth = JSON.parse(decodeURI(stateFromUrl)).invitationCode;
                } catch (e) {
                }
                if (invitationCodeFromStateOauth) {
                    this.props.googleSignIn({ code, invitationCode: invitationCodeFromStateOauth });
                } else {
                    this.props.googleSignIn({ code, });
                }
            }
        }
    }

    validatePassword = ({ password }) => {
        if (!password) {
            return 'Enter your password';
        }
        return null;
    }

    validateEmail = ({ email }) => {
        if (!isValidEmail(email)) {
            return 'Enter valid email address';
        }
        if (!email) {
            return 'Enter an email address';
        }
        return null;
    }

    signIn = (signInData) => {
        const { verify, email, hex, trackUserAction } = this.props;
        const { tryingToSignUpAutomaticallyAfterVerifiengEmail } = this.state;

        const userData = {
            email: tryingToSignUpAutomaticallyAfterVerifiengEmail ?
                (email || signInData.email) :
                (signInData.email || email),
            hex: hex
        };

        GaService.sendSignInEvent();

        var promise = new Promise((resolve, reject) => {
            this.props.signIn({
                ...userData,
                password: signInData.password,
            }).then(() => {
                resolve();
                if (verify && email && hex) {
                    trackUserAction({ action: userVerificationEvents.signInSuccess, ...userData });
                }
            });
        });

        return promise;
    }

    signInWithGoogle = () => {
        GaService.sendSignInWGoogleEvent();
        this.props.getGoogleOauthUrl().then((authUrl) => {
            showOauthDialog(authUrl);
        });
    }

    signInWithGithub = () => {
        GaService.sendSignInWGitHubEvent();
        this.props.getGithubOauthUrl().then((authUrl) => {
            showOauthDialog(authUrl);
        });
    }

    render() {
        const { email, logInInProcess, features } = this.props;
        const { tryingToSignUpAutomaticallyAfterVerifiengEmail, googleLogInInProcess, githubLogInInProcess } = this.state;
        const emailSignInHeader = `${isGoogleAuthAvailable(features) || isGithubAuthAvailable(features) ? 'Or ' : ''}Sign In with Email`;

        return (
            <div className="sign-in-form">
                {isGoogleAuthAvailable(features) && <GoogleButton
                    onClickAction={this.signInWithGoogle}
                    title="Sign In with Google"
                    authInProcess={googleLogInInProcess}
                    className="g-track-sign-in-with-google" />}
                {isGithubAuthAvailable(features) && <GithubButton
                    onClickAction={this.signInWithGithub}
                    title="Sign In with Github"
                    inProcess={githubLogInInProcess}
                    className="g-track-sign-in-with-github" />}
                {isEmailAuthAvailable(features) && <>

                    <LoginFormSubtitle title={emailSignInHeader} />

                    <ValidationForm
                        enableActionBtnByDefault={true}
                        enableActionBtnAlways={true}
                        inputs={[
                            {
                                label: "Email",
                                name: "email",
                                value: email,
                                disabled: email
                                    ? (tryingToSignUpAutomaticallyAfterVerifiengEmail ||
                                        googleLogInInProcess ||
                                        githubLogInInProcess)
                                    : (googleLogInInProcess || githubLogInInProcess),
                                autoComplete: "email",
                                tabIndex: 1,
                                applyOnEnter: true,
                                rules: [this.validateEmail],
                                onChange: this.props.onEmailChange
                            },
                            {
                                label: "Password",
                                name: "password",
                                value: '',
                                autoFocus: email ? true : false,
                                type: "password",
                                disabled: tryingToSignUpAutomaticallyAfterVerifiengEmail || googleLogInInProcess || githubLogInInProcess,
                                tabIndex: 2,
                                applyOnEnter: true,
                                rules: [this.validatePassword]
                            }
                        ]}
                        buttons={[{
                            key: 'ok',
                            content: <React.Fragment><img src={signInLogo} />Sign In</React.Fragment>,
                            action: this.signIn,
                            className: `sign-in-form_btn light ${(logInInProcess || tryingToSignUpAutomaticallyAfterVerifiengEmail) && 'btn-loader'} ${googleLogInInProcess && 'disabled'} g-track-sign-in-with-email`
                        }]}
                    />
                    <Link to={routeInfo.restorePassword.path} className="sign-in-form_forgot-pswd-link">
                        <b>Forgot your password?</b>
                    </Link>
                </>}
                {!isAnyAuthAvailable(features) && <div className="sign-in-form_no-login">Please, contact <a href="mailto:support@alan.app"
                    target="_blank" rel="noreferrer">support</a> to specify the sign in methods</div>}
            </div>
        );
    }
}


function mapStateToProps({ config }) {
    return {
        features: config.features
    };
}

function mapDispatchToProps(dispatch) {
    return {
        signIn: (param) => asyncDispatch(actions.signIn, dispatch, param),
        getGoogleOauthUrl: (param) => asyncDispatch(actions.getGoogleOauthUrl, dispatch, param),
        googleSignIn: (param) => asyncDispatch(actions.googleSignIn, dispatch, param),
        getGithubOauthUrl: (param) => asyncDispatch(actions.getGithubOauthUrl, dispatch, param),
        githubSignIn: (param) => asyncDispatch(actions.githubSignIn, dispatch, param),
        trackUserAction: (param) => asyncDispatch(analyticsActions.trackUserAction, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignInForm);